import { useTranslations } from '@/shared/i18n';
import { useSessionStore } from '@/store/session.store';

/**
 * Просьба разрешить боту писать.
 *
 * Telegram не даёт боту заговорить первым: тот, кто открыл мини-приложение по
 * прямой ссылке, минуя переписку с ботом, напоминаний не получит и об этом не
 * узнает. Строка появляется только у таких людей и исчезает, как только
 * разрешение выдано.
 *
 * Старые клиенты Telegram о разрешении не сообщают вовсе — там строки нет:
 * выпрашивать согласие у того, кто его уже дал, незачем.
 */
/** Полосой под шапкой — в «Моих чатах»; врезкой в ленту — сразу после дружбы. */
type Placement = 'bar' | 'inline';

const PLACEMENT_CLASSES: Record<Placement, string> = {
  bar: 'w-full border-b border-border bg-surface px-3 py-2',
  inline: 'max-w-[85%] self-center rounded-lg bg-surface px-3 py-2',
};

export function WriteAccessNotice({
  placement = 'bar',
}: {
  placement?: Placement;
}): React.ReactNode {
  const dictionary = useTranslations();
  const botCanWrite = useSessionStore((state) => state.botCanWrite);
  const notificationsEnabled = useSessionStore((state) => state.user?.notificationsEnabled ?? false);
  const askBotWriteAccess = useSessionStore((state) => state.askBotWriteAccess);

  if (botCanWrite !== false || !notificationsEnabled) {
    return null;
  }

  return (
    <button
      type="button"
      className={`flex items-center gap-2 text-left active:opacity-70 ${PLACEMENT_CLASSES[placement]}`}
      onClick={() => void askBotWriteAccess()}
    >
      <span className="flex-1 text-[12px] leading-snug text-text-muted">
        {dictionary.saved.permissionText}
      </span>
      <span className="shrink-0 text-[12px] font-medium text-accent">
        {dictionary.saved.permissionAction}
      </span>
    </button>
  );
}
